<div class="fourohfour">
  <app-logo class="fourohfour__logo"></app-logo>
  <app-icon class="fourohfour__icon">not_listed_location</app-icon>
  <p class="fourohfour__text">That page was not found</p>
  <p class="fourohfour__text">Try going <a routerLink="/">home</a>.</p>
</div>
